/* eslint-disable react/display-name */
import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Divider, Row } from 'antd'
import { numberWithComma } from 'helpers/format'
import { InfoItem } from 'Pages/Orders/components'
import { SupplierInvoiceData } from 'Store/supplier-invoice/types'

type Props = {
  detail?: SupplierInvoiceData
}

const SummaryPayment: React.FunctionComponent<Props> = props => {
  const { detail } = props

  const renderInfo = (title: any, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  return (
    <BoxWrapper>
      <BoxTitle>สรุป</BoxTitle>
      <Row gutter={8}>
        <Col span={24}>
          {renderInfo('จำนวนเงินรวมทั้งหมด', `${numberWithComma(detail?.total_amount || 0, true)} บาท`)}
          {renderInfo(
            'ยอดชำระทั้งหมด',
            <span>{numberWithComma(detail?.total_partial_amount, true)} บาท</span>,
          )}
          <Divider />
          {renderInfo(
            <SummaryPrice>ยอดที่ค้างชำระ</SummaryPrice>,
            <>
              <Price>{numberWithComma(detail?.total_remain_amount || 0, true)} </Price>{' '}
              <SummaryPrice>บาท</SummaryPrice>
            </>,
          )}
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`
const Price = styled.span`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title2};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const SummaryPrice = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

export default SummaryPayment
